import { render, staticRenderFns } from "./DogovorOfertyFl.vue?vue&type=template&id=53e676f6"
import script from "./DogovorOfertyFl.vue?vue&type=script&lang=js"
export * from "./DogovorOfertyFl.vue?vue&type=script&lang=js"
import style0 from "./DogovorOfertyFl.vue?vue&type=style&index=0&id=53e676f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports